export const POPOUT = {
  SMART_SPINNER: 'smartSpinner',
  ERROR_SNACKBAR: 'errorSnackbar',
  SUCCESS_SNACKBAR: 'successSnackbar',
  POPOUT_ALERT: 'popoutAlert',
  SHARING_POPOUT: 'sharingPopout'
} as const;

export type PopoutType = typeof POPOUT[keyof typeof POPOUT];
